// Shared gallery layout constants (single source of truth)
// Used for documentation, JS logic, and mirrored in CSS media queries.
// Breakpoints reflect min-width thresholds for column changes.
export const GALLERY_BREAKPOINTS = {
  LARGE: 1000, // >1000px => 5 columns
  MEDIUM: 820, // >820px => 3 columns  
  SMALL: 600   // >600px => 2 columns, <=600px => 2 columns
} as const;

export const GALLERY_COLUMNS = {
  LARGE: 5,
  MEDIUM: 3,
  SMALL: 2,
} as const;

// Helper (optional) – compute column count from width
export function galleryColumnCount(width: number): number {
  if (width > GALLERY_BREAKPOINTS.LARGE) return GALLERY_COLUMNS.LARGE;
  if (width > GALLERY_BREAKPOINTS.MEDIUM) return GALLERY_COLUMNS.MEDIUM;
  return GALLERY_COLUMNS.SMALL;
}

export const safeColCount = (w: number) => {
  const c = galleryColumnCount(w);
  if (!c || c < 2) console.warn('galleryColumnCount returned', c, 'for width', w);
  return Math.max(2, c || 0);
};